module.exports = __webpack_public_path__ + "img/Mise en place pour structure hamac.08aa8e00.jpg";